import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_56a601c8-b253-4088-9fb6-1f7146328396/artifacts/ve1u5sut_logo%20jotuns%20new1.png";

export function HeroSection() {
  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url('https://images.unsplash.com/photo-1546519638-68e109498ffc?q=80&w=2070')` 
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <img 
            src={LOGO_URL} 
            alt="Jotuns Basketball Club" 
            className="h-32 sm:h-40 md:h-48 mx-auto mb-6"
            data-testid="hero-logo"
          />
        </motion.div>
        
        <motion.h1
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold mb-4 tracking-tight"
          style={{ fontFamily: 'Barlow Condensed' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          data-testid="hero-title"
        >
          <span className="text-white">EL DEPORTE</span>
          <br />
          <span className="gradient-text">TRANSFORMA VIDAS</span>
        </motion.h1>
        
        <motion.p
          className="text-lg sm:text-xl text-zinc-300 max-w-2xl mx-auto mb-8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          data-testid="hero-subtitle"
        >
          Organización deportiva juvenil comprometida con el desarrollo integral, 
          la inclusión social y el liderazgo en Sesquilé, Cundinamarca.
        </motion.p>
        
        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <a
            href="#nosotros"
            className="btn-primary px-8 py-4 rounded-lg text-white font-semibold text-lg inline-flex items-center gap-2"
            data-testid="hero-cta-conocenos"
          >
            Conócenos
          </a>
          <a
            href="#galeria"
            className="px-8 py-4 rounded-lg border border-white/20 text-white hover:bg-white/10 transition-colors font-semibold"
            data-testid="hero-cta-galeria"
          >
            Ver Galería
          </a>
        </motion.div>
        
        {/* Scroll indicator */}
        <motion.div
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <ChevronDown className="text-orange-500" size={32} />
        </motion.div>
      </div>
    </section>
  );
}
